import React from 'react'

import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { LicenseButton, LicensesTable } from './component.styles'
import { displayAdmins, displayDate } from 'lib/util'

const Licenses = ({ licenses, onSelectUserManagement, currentUser }) => {
  const updatedLicenses = licenses.map(license => {
    const programCodes = license?.product?.programCodes || []
    const programCodesStr =
      programCodes.length > 0 ? programCodes.join('-') : 'unknown'
    return {
      ...license,
      dataTestId: `assigned-license-licenseId-${license.nsLicenseId}-programCodes-${programCodesStr}`,
    }
  })

  const columns = [
    {
      title: 'School',
      fieldValue: row => row?.site?.name || '-',
    },
    {
      title: 'Product',
      fieldValue: row => row.product?.description || '-',
    },
    {
      title: 'License ID',
      fieldValue: row => row.nsName || '-',
    },
    {
      title: 'Contract Line Id',
      fieldValue: row => row.contractLineNSId || '-',
      cellClassName: 'text-center',
    },
    {
      title: 'Expiration Date',
      fieldValue: row => displayDate(row.expirationDate),
      sortValue: 'expirationDate',
    },
    {
      title: 'Administrators',
      fieldValue: row => displayAdmins(row?.site, currentUser.email) || '-',
    },
    {
      title: '',
      fieldValue: row => {
        if (
          row?.site?.admins?.length === 0 ||
          !row?.site?.admins?.some(
            admin =>
              admin.email.toLowerCase() === currentUser.email.toLowerCase(),
          )
        ) {
          return (
            <div style={{ display: 'flex', justifyContent: 'center' }}>-</div>
          )
        }
        return (
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <LicenseButton
              dataTestId="button-manage-users"
              hasUsers={row.hasUsers}
              onClick={() => onSelectUserManagement(row.site?.id)}
            >
              {row.site?.hasUsers ? 'Manage Users' : 'Add Users'}
            </LicenseButton>
          </div>
        )
      },
      sort: false,
      filter: false,
      cellClassName: 'text-center',
    },
  ]

  return (
    <LicensesTable
      columns={columns}
      filter={false}
      headThemeLight
      key="assigned-users-autotable"
      rows={updatedLicenses}
      sort
    />
  )
}

Licenses.propTypes = {
  currentUser: PropTypes.object.isRequired,
  licenses: PropTypes.arrayOf(PropTypes.object).isRequired,
  onSelectUserManagement: PropTypes.func,
}

const mapStateToProps = ({ userProfileManager }) => {
  return {
    currentUser: userProfileManager.profile,
  }
}

export default connect(mapStateToProps)(Licenses)
